import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, roles }) {
  const { user } = useAuth();
  if (user === null) {
    return <div className="min-h-[60vh] grid place-items-center text-slate-500">Chargement…</div>;
  }
  if (user === false) return <Navigate to="/connexion" replace />;
  if (roles && !roles.includes(user.role) && user.role !== "admin") return <Navigate to="/tableau-de-bord" replace />;
  return children;
}
